import { STRINGS } from '../../constants';
import apiCaller from '../http';
import URLS from '../urls';

const deleteCar = async (profileId, ownershipId, refreshCars, setError, logoutHandler) => {
  await apiCaller
    .delete(`${URLS.CARS_LIST}${profileId}${URLS.SCANNED_CAR_DELETE}${ownershipId}/`)
    .then((resp) => {
      if (resp.data !== undefined) {
        setError(null);
        refreshCars();
      } else {
        setError(STRINGS.common.error404Text);
      }
    })
    .catch((e) => {
      if (e.message === STRINGS.settings.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.settings.error400Template) {
        setError(STRINGS.settings.error400Text);
      }
    });
};

export default deleteCar;
